import { pattern } from "../common";
import { rhfRules } from "../../rhf/rules";

// Fields a Point of Contact can have; `rules` are the field's own validation
export const pocFieldConfigs = {
  email: { label: "email", value: "", rules: rhfRules.pattern(pattern.email) },
  role: { label: "role", defaultValue: true, value: "" },
  first_name_prefix: { label: "prefix", defaultValue: true, value: "mr", rules: rhfRules.maxLength(50) },
  first_name: { label: "first_name", value: "",rules: rhfRules.maxLength(50) },
  last_name: { label: "last_name", value: "", rules: rhfRules.maxLength(100) },
  phone: { label: "phone_number", value: "", rules: rhfRules.phoneLength },
  // shown but not changeable: Points of Contact keep the default country code
  countryCode: { label: "countryCode", defaultValue: true, value: "+1", rules: rhfRules.required, disabled: true },
};
